import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// mui imports
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';
import MenuItem from '@mui/material/MenuItem';
import { apiCall } from '../../utils/action';
import Menu from '@mui/material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MailIcon from '@mui/icons-material/Mail';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import Settings from '@mui/icons-material/Settings';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import PersonIcon from '@mui/icons-material/Person';
import Preloader from '../../helpers/Preloader';
// custom style imports
import '../../../assets/styles/containers/_header.scss';
import CircleIcon from '@mui/icons-material/Circle';
// component imports
import toast from 'react-hot-toast';
import { getDashboardRedirectUrl } from '../../utils/dashboardRedirect';

const Header = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
    const [showLoader, setShowLoader] = useState();
    const isMenuOpen = Boolean(anchorEl);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
    let navigate = useNavigate();
    const location = useLocation();
    const isOnCommentLibrary = location.pathname === '/library';
    const dashboardHref = getDashboardRedirectUrl() || '#/dashboard';
    // authentication
    const roleId = sessionStorage.getItem('role_id');
    let permission = roleId === '7' ? false : true;
    let ptPermission = roleId === '4' ? false : true;

    let PTadminFlag = roleId === '2' || roleId === '3' || roleId === '4' ? true : false;

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        handleMobileMenuClose();
    };
    const signOut = () => {
        setShowLoader(true);
        handleMenuClose();
        const formdata = { token: sessionStorage.getItem('token') };
        apiCall(
            (response) => {
                console.log('LOGOUT', response);
                if (response.data.success) {
                    toast.success(response.data.message);
                    sessionStorage.clear();
                    navigate('/');
                    setShowLoader(false);
                } else {
                    console.log('else', response.data.message);
                    // nedd to handle the unauthorised condition here fro now the response toast is commented
                    // toast.error(response.data.message);                    
                    sessionStorage.clear();
                    navigate('/');
                    setShowLoader(false);
                }
            },
            formdata,
            'LOGOUT',
        );
    };
    // const signOut = () => {
    //     setShowLoader(true);
    //     handleMenuClose();
    //     const formdata = { token: sessionStorage.getItem('token') };
    //     axios
    //         .post(`${API_CONSTANTS.LOGOUT}`, formdata)
    //         .then((response) => {
    //             toast.success(response.data.message);
    //             sessionStorage.clear();
    //             navigate('/');
    //             setShowLoader(false);
    //         })
    //         .catch(function (error) {
    //             if (error.response) {
    //                 // Request made and server responded
    //                 if (error.response.data.success === false) {
    //                     toast.error(error.response.data.message);
    //                     setShowLoader(false);
    //                 }
    //                 console.log(error.response.headers);
    //             } else if (error.request) {
    //                 // The request was made but no response was received
    //                 console.log('no response', error.request);
    //             } else {
    //                 // Something happened in setting up the request that triggered an Error
    //                 console.log('Error', error.message);
    //             }
    //         });
    // };

    const menuId = 'primary-search-account-menu';
    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            className="profile-menuitem"
            id={menuId}
            keepMounted
            open={isMenuOpen}
            onClose={handleMenuClose}
            PaperProps={{
                elevation: 0,
                sx: {
                    'overflow': 'visible',
                    'filter': 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    'mt': -1,
                    '& .MuiAvatar-root': {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                    },
                    '&:before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        right: 34,
                        width: 10,
                        height: 10,
                        bgcolor: 'background.paper',
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex: 0,
                    },
                },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
            {!PTadminFlag && (
                <MenuItem id="settings" name="settings"
                    onClick={() => {
                        handleMenuClose();
                        navigate('/settings');
                    }}>
                    <ListItemIcon>
                        <Settings fontSize="small" />
                    </ListItemIcon>
                    Settings
                </MenuItem>
            )}
            {!permission && (
                <MenuItem id="my__pt_profile" name="my_pt_profile"
                    onClick={() => {
                        handleMenuClose();
                        navigate('/my-profile');
                    }}>
                    <ListItemIcon>
                        <PersonIcon fontSize="small" />
                    </ListItemIcon>
                    My Profile
                </MenuItem>
            )}
            {!ptPermission && (
                <MenuItem id="my_profile" name="my_profile"
                    onClick={() => {
                        handleMenuClose();
                        navigate('/profile');
                    }}>
                    <ListItemIcon>
                        <PersonIcon fontSize="small" />
                    </ListItemIcon>
                    My Profile
                </MenuItem>
            )}
            {/* {permission && (
                <MenuItem
                    onClick={() => {
                        handleMenuClose();
                        navigate('/settings/team');
                    }}>
                    <ListItemIcon>
                        <ReceiptIcon fontSize="small" />
                    </ListItemIcon>
                    Team
                </MenuItem>
            )} */}
            {/* <MenuItem id="contact_us" name="contact_us"
            // onClick={() => { handleMenuClose();}}
            >
                <ListItemIcon>
                    <ForumIcon fontSize="small" />
                </ListItemIcon>
                Contact us
            </MenuItem> */}
            <Divider />
            <MenuItem onClick={signOut} id="sign_out" name="sign_out">
                <ListItemIcon>
                    <ExitToAppIcon fontSize="small" />
                </ListItemIcon>
                Sign out
            </MenuItem>
        </Menu>
    );

    const mobileMenuId = 'primary-search-account-menu-mobile';
    const renderMobileMenu = (
        <Menu
            anchorEl={mobileMoreAnchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={mobileMenuId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMobileMenuOpen}
            onClose={handleMobileMenuClose}>
            <MenuItem>
                <IconButton size="large" aria-label="show 4 new mails" color="inherit">
                    <Badge badgeContent={4} color="error">
                        <MailIcon />
                    </Badge>
                </IconButton>
                <p>Messages</p>
            </MenuItem>
            {/* <MenuItem>
                <IconButton size="large" aria-label="show 17 new notifications" color="inherit">
                    <Badge badgeContent={17} color="error">
                        <NotificationsIcon />
                    </Badge>
                </IconButton>
                <p>Notifications</p>
            </MenuItem> */}
            <MenuItem onClick={handleProfileMenuOpen}>
                <IconButton size="large" aria-label="account of current user" aria-controls="primary-search-account-menu" aria-haspopup="true" color="inherit">
                    <AccountCircle />
                </IconButton>
                <KeyboardArrowDownIcon />
                <p>Profile</p>
            </MenuItem>
        </Menu>
    );
    return (
        <div className="header-fixed">
            <Preloader showPreloader={showLoader} />
            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="static" className="header-app-bar">
                    <Toolbar>
                        <IconButton id="pt_logo" name="pt_logo" size="large" edge="start" color="inherit" aria-label="open drawer" sx={{ mr: 2 }} className="main-logo" component="a" href={dashboardHref} disableRipple>
                            <img className="isn-header-logo" src={"https://dlil96nns7nd5.cloudfront.net/images/isn-white-transparent-140x70.png"} alt="logo" />
                        </IconButton>
                        <Box sx={{ flexGrow: 1 }} />
                        {/* Searchbar for large Screen and hidden in small screen */}
                        <Box className="header-search-wrapper">
                            {/* <Search className="header-search-bar">
                                <SearchIconWrapper>
                                    <SearchIcon />
                                </SearchIconWrapper>
                                <StyledInputBase placeholder="Search…" inputProps={{ 'aria-label': 'search' }} />
                            </Search> */}
                        </Box>
                        <Box>
                            {/* <IconButton id="notification" name="notification" size="large" aria-label="show 17 new notifications" color="inherit" className="notification-icon" disableRipple>
                                <Badge badgeContent={17} color="error" className="notification-badge">
                                    <NotificationsIcon />
                                </Badge>
                            </IconButton> */}
                            {!isOnCommentLibrary && <IconButton sx={{ gap: "3px" }} size="large" onClick={() => navigate("/library")} >
                                {/* <Avatar sx={{ bgcolor: 'white' }}>
                                    <PersonIcon className="navbar-profile-icon" />
                                </Avatar> */}
                                <CircleIcon sx={{ fontSize: "5px", color: "white" }} />
                                <Typography className='header-title'>Content Library</Typography>
                                {/* <KeyboardArrowDownIcon sx={{ fontSize: '18px', marginTop: '2px' }} /> */}
                            </IconButton>}
                        </Box>
                    </Toolbar>
                </AppBar>
                {/* {renderMobileMenu}
                {renderMenu} */}
            </Box>
            {/* <Navbar permission={permission} PTadminFlag={PTadminFlag} roleId={roleId} ptPermission={ptPermission} /> */}
        </div>
    );
};

export default Header;
